"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2, FiEye, FiSearch } from "react-icons/fi"
import "./Customers.css"

const Customers = () => {
    const [customers, setCustomers] = useState([])
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [searchTerm, setSearchTerm] = useState("")
    const [filters, setFilters] = useState({
        category: "",
        contact_status: "",
        payment_status: "",
    })
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        company_name: "",
        tax_number: "",
        category: "",
        phone: "",
        email: "",
        address: "",
        position: "",
        contact_status: "not_contacted",
        app_interest: "",
        payment_status: "not_paid",
        payment_amount: "",
        transaction_date: "",
        notes: "",
        assigned_to: "",
    })
    const [error, setError] = useState("")

    const categories = [
        "Kadın Kuaförü",
        "Erkek Kuaförü",
        "Güzellik Salonu",
        "Berber",
        "Psikolog",
        "Diyetisyen",
        "Fitness",
        "Yoga",
        "Masaj",
        "Diğer",
    ]

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [customersRes, usersRes] = await Promise.all([api.get("/customers"), api.get("/users")])
            setCustomers(customersRes.data.data || customersRes.data)
            setUsers(usersRes.data.data || usersRes.data)
        } catch (error) {
            console.error("Veri yüklenemedi:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        try {
            if (selectedCustomer) {
                await api.put(`/customers/${selectedCustomer.id}`, formData)
            } else {
                await api.post("/customers", formData)
            }
            setShowModal(false)
            resetForm()
            loadData()
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız")
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu müşteriyi silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/customers/${id}`)
            loadData()
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const handleEdit = (customer) => {
        setSelectedCustomer(customer)
        setFormData({
            first_name: customer.first_name,
            last_name: customer.last_name,
            company_name: customer.company_name || "",
            tax_number: customer.tax_number || "",
            category: customer.category || "",
            phone: customer.phone || "",
            email: customer.email || "",
            address: customer.address || "",
            position: customer.position || "",
            contact_status: customer.contact_status,
            app_interest: customer.app_interest || "",
            payment_status: customer.payment_status,
            payment_amount: customer.payment_amount || "",
            transaction_date: customer.transaction_date || "",
            notes: customer.notes || "",
            assigned_to: customer.assigned_to || "",
        })
        setShowModal(true)
    }

    const handleViewDetail = async (customer) => {
        try {
            const response = await api.get(`/customers/${customer.id}`)
            setSelectedCustomer(response.data)
            setShowDetailModal(true)
        } catch (error) {
            alert("Detay yüklenemedi")
        }
    }

    const resetForm = () => {
        setFormData({
            first_name: "",
            last_name: "",
            company_name: "",
            tax_number: "",
            category: "",
            phone: "",
            email: "",
            address: "",
            position: "",
            contact_status: "not_contacted",
            app_interest: "",
            payment_status: "not_paid",
            payment_amount: "",
            transaction_date: "",
            notes: "",
            assigned_to: "",
        })
        setSelectedCustomer(null)
        setError("")
    }

    const filteredCustomers = customers.filter((customer) => {
        const matchesSearch =
            customer.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (customer.company_name && customer.company_name.toLowerCase().includes(searchTerm.toLowerCase()))

        const matchesCategory = !filters.category || customer.category === filters.category
        const matchesContact = !filters.contact_status || customer.contact_status === filters.contact_status
        const matchesPayment = !filters.payment_status || customer.payment_status === filters.payment_status

        return matchesSearch && matchesCategory && matchesContact && matchesPayment
    })

    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    return React.createElement(
        "div",
        { className: "customers-page" },
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "Müşteri Yönetimi"),
            React.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: () => {
                        resetForm()
                        setShowModal(true)
                    },
                },
                React.createElement(FiPlus),
                "Yeni Müşteri",
            ),
        ),
        React.createElement(
            "div",
            { className: "card filters-card" },
            React.createElement(
                "div",
                { className: "search-box" },
                React.createElement(FiSearch, { className: "search-icon" }),
                React.createElement("input", {
                    type: "text",
                    placeholder: "Müşteri ara...",
                    value: searchTerm,
                    onChange: (e) => setSearchTerm(e.target.value),
                }),
            ),
            React.createElement(
                "div",
                { className: "filters" },
                React.createElement(
                    "select",
                    {
                        value: filters.category,
                        onChange: (e) => setFilters({ ...filters, category: e.target.value }),
                    },
                    React.createElement("option", { value: "" }, "Tüm Kategoriler"),
                    categories.map((cat) => React.createElement("option", { key: cat, value: cat }, cat)),
                ),
                React.createElement(
                    "select",
                    {
                        value: filters.contact_status,
                        onChange: (e) => setFilters({ ...filters, contact_status: e.target.value }),
                    },
                    React.createElement("option", { value: "" }, "Tüm İletişim Durumları"),
                    React.createElement("option", { value: "not_contacted" }, "İletişime Geçilmedi"),
                    React.createElement("option", { value: "contacted_positive" }, "Olumlu"),
                    React.createElement("option", { value: "contacted_negative" }, "Olumsuz"),
                ),
                React.createElement(
                    "select",
                    {
                        value: filters.payment_status,
                        onChange: (e) => setFilters({ ...filters, payment_status: e.target.value }),
                    },
                    React.createElement("option", { value: "" }, "Tüm Ödeme Durumları"),
                    React.createElement("option", { value: "paid" }, "Ödendi"),
                    React.createElement("option", { value: "not_paid" }, "Ödenmedi"),
                    React.createElement("option", { value: "partial" }, "Kısmi"),
                ),
            ),
        ),
        React.createElement(
            "div",
            { className: "card" },
            React.createElement(
                "div",
                { className: "table-container" },
                React.createElement(
                    "table",
                    { className: "desktop-table" },
                    React.createElement(
                        "thead",
                        null,
                        React.createElement(
                            "tr",
                            null,
                            React.createElement("th", null, "Ad Soyad"),
                            React.createElement("th", null, "Şirket"),
                            React.createElement("th", null, "Kategori"),
                            React.createElement("th", null, "İletişim"),
                            React.createElement("th", null, "Ödeme"),
                            React.createElement("th", null, "Sorumlu"),
                            React.createElement("th", null, "İşlemler"),
                        ),
                    ),
                    React.createElement(
                        "tbody",
                        null,
                        filteredCustomers.map((customer) =>
                            React.createElement(
                                "tr",
                                { key: customer.id },
                                React.createElement("td", null, `${customer.first_name} ${customer.last_name}`),
                                React.createElement("td", null, customer.company_name || "-"),
                                React.createElement("td", null, customer.category || "-"),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "span",
                                        {
                                            className: `badge ${
                                                customer.contact_status === "contacted_positive"
                                                    ? "badge-success"
                                                    : customer.contact_status === "contacted_negative"
                                                        ? "badge-danger"
                                                        : "badge-warning"
                                            }`,
                                        },
                                        customer.contact_status === "contacted_positive"
                                            ? "Olumlu"
                                            : customer.contact_status === "contacted_negative"
                                                ? "Olumsuz"
                                                : "Beklemede",
                                    ),
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "span",
                                        {
                                            className: `badge ${
                                                customer.payment_status === "paid"
                                                    ? "badge-success"
                                                    : customer.payment_status === "partial"
                                                        ? "badge-warning"
                                                        : "badge-danger"
                                            }`,
                                        },
                                        customer.payment_status === "paid"
                                            ? "Ödendi"
                                            : customer.payment_status === "partial"
                                                ? "Kısmi"
                                                : "Ödenmedi",
                                    ),
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    customer.assigned_user
                                        ? `${customer.assigned_user.first_name} ${customer.assigned_user.last_name}`
                                        : "-",
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "div",
                                        { className: "action-buttons" },
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon", onClick: () => handleViewDetail(customer) },
                                            React.createElement(FiEye),
                                        ),
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon", onClick: () => handleEdit(customer) },
                                            React.createElement(FiEdit2),
                                        ),
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon danger", onClick: () => handleDelete(customer.id) },
                                            React.createElement(FiTrash2),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            React.createElement(
                "div",
                { className: "mobile-cards" },
                filteredCustomers.map((customer) =>
                    React.createElement(
                        "div",
                        { key: customer.id, className: "mobile-card" },
                        React.createElement(
                            "div",
                            { className: "mobile-card-header" },
                            React.createElement("h3", null, `${customer.first_name} ${customer.last_name}`),
                            React.createElement(
                                "div",
                                { className: "action-buttons" },
                                React.createElement(
                                    "button",
                                    { className: "btn-icon", onClick: () => handleViewDetail(customer) },
                                    React.createElement(FiEye),
                                ),
                                React.createElement(
                                    "button",
                                    { className: "btn-icon", onClick: () => handleEdit(customer) },
                                    React.createElement(FiEdit2),
                                ),
                                React.createElement(
                                    "button",
                                    { className: "btn-icon danger", onClick: () => handleDelete(customer.id) },
                                    React.createElement(FiTrash2),
                                ),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-body" },
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Şirket:"),
                                React.createElement("span", { className: "value" }, customer.company_name || "-"),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Kategori:"),
                                React.createElement("span", { className: "value" }, customer.category || "-"),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "İletişim:"),
                                React.createElement(
                                    "span",
                                    {
                                        className: `badge ${
                                            customer.contact_status === "contacted_positive"
                                                ? "badge-success"
                                                : customer.contact_status === "contacted_negative"
                                                    ? "badge-danger"
                                                    : "badge-warning"
                                        }`,
                                    },
                                    customer.contact_status === "contacted_positive"
                                        ? "Olumlu"
                                        : customer.contact_status === "contacted_negative"
                                            ? "Olumsuz"
                                            : "Beklemede",
                                ),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Ödeme:"),
                                React.createElement(
                                    "span",
                                    {
                                        className: `badge ${
                                            customer.payment_status === "paid"
                                                ? "badge-success"
                                                : customer.payment_status === "partial"
                                                    ? "badge-warning"
                                                    : "badge-danger"
                                        }`,
                                    },
                                    customer.payment_status === "paid"
                                        ? "Ödendi"
                                        : customer.payment_status === "partial"
                                            ? "Kısmi"
                                            : "Ödenmedi",
                                ),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Sorumlu:"),
                                React.createElement(
                                    "span",
                                    { className: "value" },
                                    customer.assigned_user
                                        ? `${customer.assigned_user.first_name} ${customer.assigned_user.last_name}`
                                        : "-",
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        ),
        showModal &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowModal(false) },
            React.createElement(
                "div",
                { className: "modal modal-large", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, selectedCustomer ? "Müşteri Düzenle" : "Yeni Müşteri"),
                error && React.createElement("div", { className: "error-message" }, error),
                React.createElement(
                    "form",
                    { onSubmit: handleSubmit },
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Ad *"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.first_name,
                                onChange: (e) => setFormData({ ...formData, first_name: e.target.value }),
                                required: true,
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Soyad *"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.last_name,
                                onChange: (e) => setFormData({ ...formData, last_name: e.target.value }),
                                required: true,
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Şirket Adı"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.company_name,
                                onChange: (e) => setFormData({ ...formData, company_name: e.target.value }),
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Vergi No"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.tax_number,
                                onChange: (e) => setFormData({ ...formData, tax_number: e.target.value }),
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Kategori"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.category,
                                    onChange: (e) => setFormData({ ...formData, category: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Seçiniz"),
                                categories.map((cat) => React.createElement("option", { key: cat, value: cat }, cat)),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Pozisyon"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.position,
                                onChange: (e) => setFormData({ ...formData, position: e.target.value }),
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Telefon"),
                            React.createElement("input", {
                                type: "text",
                                value: formData.phone,
                                onChange: (e) => setFormData({ ...formData, phone: e.target.value }),
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "E-posta"),
                            React.createElement("input", {
                                type: "email",
                                value: formData.email,
                                onChange: (e) => setFormData({ ...formData, email: e.target.value }),
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Adres"),
                        React.createElement("textarea", {
                            value: formData.address,
                            onChange: (e) => setFormData({ ...formData, address: e.target.value }),
                            rows: 2,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "İletişim Durumu"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.contact_status,
                                    onChange: (e) => setFormData({ ...formData, contact_status: e.target.value }),
                                },
                                React.createElement("option", { value: "not_contacted" }, "İletişime Geçilmedi"),
                                React.createElement("option", { value: "contacted_positive" }, "Olumlu"),
                                React.createElement("option", { value: "contacted_negative" }, "Olumsuz"),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Uygulama İlgisi"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.app_interest,
                                    onChange: (e) => setFormData({ ...formData, app_interest: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Seçiniz"),
                                React.createElement("option", { value: "will_buy" }, "Alacak"),
                                React.createElement("option", { value: "reviewing" }, "İnceliyor"),
                                React.createElement("option", { value: "demo_sent" }, "Demo Gönderildi"),
                                React.createElement("option", { value: "not_interested" }, "İlgilenmiyor"),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Ödeme Durumu"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.payment_status,
                                    onChange: (e) => setFormData({ ...formData, payment_status: e.target.value }),
                                },
                                React.createElement("option", { value: "not_paid" }, "Ödenmedi"),
                                React.createElement("option", { value: "paid" }, "Ödendi"),
                                React.createElement("option", { value: "partial" }, "Kısmi"),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Ödeme Tutarı"),
                            React.createElement("input", {
                                type: "number",
                                step: "0.01",
                                value: formData.payment_amount,
                                onChange: (e) => setFormData({ ...formData, payment_amount: e.target.value }),
                            }),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "İşlem Tarihi"),
                            React.createElement("input", {
                                type: "date",
                                value: formData.transaction_date,
                                onChange: (e) => setFormData({ ...formData, transaction_date: e.target.value }),
                            }),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Sorumlu Personel"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.assigned_to,
                                    onChange: (e) => setFormData({ ...formData, assigned_to: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Seçiniz"),
                                users.map((user) =>
                                    React.createElement(
                                        "option",
                                        { key: user.id, value: user.id },
                                        `${user.first_name} ${user.last_name}`,
                                    ),
                                ),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Notlar"),
                        React.createElement("textarea", {
                            value: formData.notes,
                            onChange: (e) => setFormData({ ...formData, notes: e.target.value }),
                            rows: 3,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "modal-actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                            "İptal",
                        ),
                        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
                    ),
                ),
            ),
        ),
        showDetailModal &&
        selectedCustomer &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowDetailModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, "Müşteri Detayı"),
                React.createElement(
                    "div",
                    { className: "detail-grid" },
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Ad Soyad:"),
                        React.createElement("span", null, `${selectedCustomer.first_name} ${selectedCustomer.last_name}`),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Şirket:"),
                        React.createElement("span", null, selectedCustomer.company_name || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Kategori:"),
                        React.createElement("span", null, selectedCustomer.category || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Telefon:"),
                        React.createElement("span", null, selectedCustomer.phone || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "E-posta:"),
                        React.createElement("span", null, selectedCustomer.email || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Adres:"),
                        React.createElement("span", null, selectedCustomer.address || "-"),
                    ),
                    React.createElement(
                        "div",
                        { className: "detail-item" },
                        React.createElement("strong", null, "Notlar:"),
                        React.createElement("span", null, selectedCustomer.notes || "-"),
                    ),
                ),
                React.createElement(
                    "div",
                    { className: "modal-actions" },
                    React.createElement(
                        "button",
                        { className: "btn btn-secondary", onClick: () => setShowDetailModal(false) },
                        "Kapat",
                    ),
                ),
            ),
        ),
    )
}

export default Customers
